






















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  QBtn,
  QIcon,
  QSpinner,
  QStep,
  QStepper,
  QTooltip,
  QUploader,
  QUploaderAddTrigger,
} from 'quasar'
import { download } from '@/domains/file/download-file'

enum EUploadState {
  ANALYZE = 'analyze',
  CONFIRM = 'confirm'
}

interface IUploaderEvent {
  files: []
  xhr: XMLHttpRequest
}

@Component({
  components: {
    QBtn,
    QIcon,
    QSpinner,
    QStep,
    QStepper,
    QTooltip,
    QUploader,
    QUploaderAddTrigger,
  },
})
export default class UploadArticlePanel extends Vue {
  @Prop({ required: true, type: String }) public step!: EUploadState
  @Prop({ required: true, type: Boolean }) public resetUpload!: boolean
  @Prop({ required: true, type: String }) public uploadLink!: string
  @Prop({ required: true, type: String }) public templateDownloadLink!: string

  public EUploadState = EUploadState

  public hideFileList = true

  public file!: File[]

  @Watch('resetUpload')
  public returnToInitialState(v: boolean): void {
    if (!v) return
    this.reset()
    this.$emit('update:resetUpload', false)
  }

  get currentStep(): EUploadState {
    return this.step
  }

  set currentStep(v: EUploadState) {
    this.$emit('update:step', v)
  }

  public reset(): void {
    this.currentStep = EUploadState.ANALYZE
    this.hideFileList = true
    // @ts-ignore
    this.$refs.uploader.reset()
  }

  public handleAdded(added: File[]): void {
    if (this.currentStep !== EUploadState.CONFIRM) this.file = added
    else if (this.currentStep === EUploadState.CONFIRM) {
    // @ts-ignore
      this.$refs.uploader.removeUploadedFiles()
      // @ts-ignore
      this.$refs.uploader.addFiles(this.file)
    }

    // @ts-ignore
    this.$refs.uploader.upload()
  }

  public handleUpload(info: IUploaderEvent): void {
    if (info.xhr.response !== '') {
      download(info.xhr.response, 'artikel-aanpassingen.csv')
      this.currentStep = EUploadState.CONFIRM
      return
    }

    this.reset()
    this.$emit('showMessage', { status: 'positive', message: 'Upload is geslaagd.' })

    if (this.currentStep === EUploadState.ANALYZE) {
      this.currentStep = EUploadState.CONFIRM
      this.$emit('showMessage', { status: 'positive', message: 'Upload is geslaagd.' })
      return
    }

    this.$emit('success')
  }

  public handleFailure(info: IUploaderEvent): void {
    if (info.xhr.status === 422) {
      this.$emit('showMessage', {
        status: 'negative',
        message: 'Niet alle artikelen van de upload zijn correct, corrigeer de fouten die omschreven staan ' +
        'in mislukte-artikelen.csv',
      })
      download(info.xhr.response, 'mislukte-artikelen.csv')
    } else {
      this.$emit('showMessage', {
        status: 'negative',
        message: 'Het formaat van de geüploade artikelen is onjuist. Gebruikt het onderstaande template ter' +
         ' referentie.',
      })
    }

    this.reset()
  }
}
